import { PropsWithChildren, createContext, useContext } from 'react';

import { Banner } from '@spotify-internal/encore-web';

import { LoadingOverlay } from './LoadingOverlay';

import styles from './StickyTableHead.module.css';

const StickyHeadOffsetContext = createContext(0);

export const useStickyHeadOffset = (): number =>
  useContext(StickyHeadOffsetContext);

export const StickyTableContainer = ({
  children,
  loading = false,
  error,
}: PropsWithChildren<{ loading?: boolean; error?: Error | null }>) => (
  <div className={styles.wrapper}>
    <LoadingOverlay loading={loading} />
    {error && (
      <Banner colorSet="negative" contextual>
        {error.message}
      </Banner>
    )}
    <div className={styles.tableContainer}>{children}</div>
  </div>
);

export const StickyTableHead = ({
  children,
  topOffset = 0,
}: PropsWithChildren<{ topOffset?: number }>) => (
  <StickyHeadOffsetContext.Provider value={topOffset}>
    <thead data-component="StickyTableHeader">{children}</thead>
  </StickyHeadOffsetContext.Provider>
);
